"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerDropdownInputElement = exports.renderDropdownInputItem = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _uiElements = require("@blue/ui-elements");

var _element = require("@blue/element");

var _inputFieldRenderer = require("../../../../core/render/items/input-engine/input-field-renderer");

var _fieldStyles = require("../../../../core/render/field-styles");

var _stringUtils = require("../string-utils");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-dropdown-input-field .info=\"", "\"></bm-dropdown-input-field> "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t<option value\n\t\t\t\t\t?selected=", "\n\t\t\t\t\t?disabled=", ">\n\t\t\t\t</option>"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t<option\n\t\t\t\t\t.value=", "\n\t\t\t\t\t?disabled=\"", "\"\n\t\t\t\t\t?selected=", ">\n\t\t\t\t\t", "\n\t\t\t\t</option>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-select\n\t\t\t\tlarge updated-style\n\t\t\t\tclass=\"", "\">\n\t\t\t\t<select\n\t\t\t\t\tname=", "\n\t\t\t\t\tid=", "\n\t\t\t\t\tvalue=", "\n\t\t\t\t\taria-label=", "\n\t\t\t\t\tdata-qe-id=\"", "\"\n\t\t\t\t\t?disabled=", "\n\t\t\t\t\t?aria-readonly=\"", "\"\n\t\t\t\t\t@change=", "\n\t\t\t\t\t@blur=", ">\n\t\t\t\t\t", "\n\t\t\t\t\t", "\n\t\t\t\t</select>\n\t\t\t</bm-select>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmDropdownInputFieldElement = /*#__PURE__*/function (_BmInputFieldElement) {
  (0, _inherits2.default)(BmDropdownInputFieldElement, _BmInputFieldElement);

  var _super = (0, _createSuper2.default)(BmDropdownInputFieldElement);

  function BmDropdownInputFieldElement() {
    (0, _classCallCheck2.default)(this, BmDropdownInputFieldElement);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmDropdownInputFieldElement, [{
    key: "_renderInput",
    value: function _renderInput() {
      var _context;

      var selectClasses = (0, _element.classMap)({
        'bm-fe-select': true,
        'bm-readonly': this.readonly
      });
      var items = (0, _map.default)(_context = this.info.options.items).call(_context, this._itemConverter);
      var label = (0, _stringUtils.sliceBeforeDelimiter)("".concat(this.info.name));
      var name = (0, _stringUtils.sliceFromDelimiter)("".concat(this.info.name));
      return this.html(_templateObject(), selectClasses, name, name, this.value, label, (0, _element.ifDefined)(this.info.options.dataQeId), this.disabled, this.readonly, this._handleFormEvent, this._handleFormEvent, this._renderUnselected(this.value), this._renderOptions(items, this.value, this.readonly));
    }
  }, {
    key: "_renderOption",
    value: function _renderOption(option, selected) {
      var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.html(_templateObject2(), option.value, disabled, option.value === selected, option.name);
    }
  }, {
    key: "_renderOptions",
    value: function _renderOptions(options, selected) {
      var _this = this;

      var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return (0, _repeatInstanceProperty(_element))(options, function (option) {
        return _this._renderOption(option, selected, disabled);
      });
    }
  }, {
    key: "_renderUnselected",
    value: function _renderUnselected(value) {
      if (this.readonly) return null;

      if (!this.required || !value) {
        return this.html(_templateObject3(), !value, this.required);
      }

      return null;
    }
  }, {
    key: "_handleFormEvent",
    value: function _handleFormEvent(evt) {
      if (evt.type === 'blur') {
        if (!this.info.touched) {
          this.dispatchBmFormEvent({
            type: 'touched'
          });
        }
      } else if (evt.type === 'change') {
        this.dispatchBmFormEvent({
          type: 'changed',
          data: {
            currentValue: evt.target.value,
            previousValue: this.value
          }
        });
      }
    }
  }, {
    key: "_itemConverter",
    value: function _itemConverter(option) {
      return typeof option === 'string' ? {
        name: option,
        value: option
      } : option;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-dropdown-input-field';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return _fieldStyles.bmFormFieldStyles;
    }
  }]);
  return BmDropdownInputFieldElement;
}(_inputFieldRenderer.BmInputFieldElement);

var renderDropdownInputItem = function renderDropdownInputItem(info) {
  return (0, _element.html)(_templateObject4(), info);
};

exports.renderDropdownInputItem = renderDropdownInputItem;

var registerDropdownInputElement = function registerDropdownInputElement() {
  (0, _uiElements.registerSelect)();
  (0, _element.register)(BmDropdownInputFieldElement);
};

exports.registerDropdownInputElement = registerDropdownInputElement;
